function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "WanLend",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "WanLend_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M2.86665 12V15.68L6.86666 20L10.8667 15.68V12L6.86666 16.32L2.86665 12Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M13 12V15.68L17 20L21 15.68V12L17 16.32L13 12Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M15.9334 12V8.32L11.9334 4L7.93335 8.32V12L11.9334 7.68L15.9334 12Z",
  fill: "none"
})));

var SvgWanLend = function SvgWanLend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWanLend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wan_lend.b042d558.svg";
export { ForwardRef as ReactComponent };